import { Module } from "vuex";
import { actions, LOYALTY_ACTIONS } from "./actions";
import { mutations, LOYALTY_MUTATIONS } from "./mutations";
import { getters, LOYALTY_GETTERS } from "./getters";
import {
  ILoyaltyState,
  ISegmentOffer,
  IAccountOffer,
  ICustomerSearchResponse,
  ICustomer,
  ICampaign,
  LoyaltySchemeType,
  IEarnRate
} from "./types";
import { IRootState } from "@/store/types";
import { localISOString } from "@/helpers/date";

export const emptyCustomerSearch = {
  accountNumber: null,
  computedTitle: ""
} as ICustomerSearchResponse;

export const emptyAccountOffer = {
  id: undefined,
  level: "Account",
  isEligible: true,
  channels: [],
  computedTitle: "",
  accountNumber: null,
  customerName: "",
  applicationNumber: 0,
  contactName: "",
  contactTitle: "",
  segment: "",
  customerType: "",
  emailAddress: "",
  airpointsEarnRateQuantity: 0,
  flyBuysEarnRateQuantity: 0,
  earnRates: []
} as IAccountOffer;

export const emptyCampaign = {
  id: undefined,
  name: "",
  startDate: localISOString(new Date()),
  endDate: null,
  segments: [],
  channels: [],
  flyBuysMultiplier: 1,
  airpointsMultiplier: 1,
  multipliers: [
    {
      loyaltyScheme: LoyaltySchemeType.FlyBuys,
      multiplier: 1
    },
    {
      loyaltyScheme: LoyaltySchemeType.Airpoints,
      multiplier: 1
    }
  ],
  lastUpdated: null,
  lastUpdatedBy: null
} as ICampaign;

export const state: ILoyaltyState = {
  isLoading: false,
  segmentOfferList: [],
  segmentOffer: {} as ISegmentOffer,
  segmentOfferOriginal: {} as ISegmentOffer,
  segmentOfferListPaginationTotal: 0,
  channelList: undefined,
  segmentList: undefined,
  accountOffer: {} as IAccountOffer,
  accountOfferOriginal: {} as IAccountOffer,
  accountOfferList: [],
  accountOfferListPaginationTotal: 0,
  customerSearchList: [],
  customerSearchInProgress: false,
  customerList: [],
  customerListPaginationTotal: 0,
  customer: {} as ICustomer,
  customerCardsList: [],
  customerCardsListPaginationTotal: 0,
  customerCardsListShowModal: false,
  activeCustomerCard: undefined,
  customerTransactionList: [],
  customerPointsList: [],
  activeCampaign: {} as ICampaign,
  activeCampaignOriginal: {} as ICampaign,
  campaignList: [],
  campaignListPaginationTotal: 0,
  dataTables: {
    accountOffers: {
      pagination: {
        sortBy: "accountNumber"
      }
    },
    segmentOffers: {
      pagination: {
        sortBy: "segmentName"
    }
    },
    campaigns: {
      pagination: {
        sortBy: "name"
      }
    },
    customerCards: {
      pagination: {
        sortBy: "cardNumber"
      }
    }
  }
};

export namespace LOYALTY {
  export const ACTIONS = LOYALTY_ACTIONS;
  export const MUTATIONS = LOYALTY_MUTATIONS;
  export const GETTERS = LOYALTY_GETTERS;
  export const NAME_SPACE = "loyalty";
  export const NS = (x: string): string => `${NAME_SPACE}/${x}`;
}

const namespaced: boolean = true;

export const loyalty: Module<ILoyaltyState, IRootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters
};
